import ViewDetails from "../../utils/utilities/ViewDetails";

import { Tab } from "@mui/material";

import GenericTab from "../../utils/utilities/GenericTab";

// NewEvent Context
import { NewEventProvider } from "../../contexts/NewEvent";

import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import StyleOutlinedIcon from '@mui/icons-material/StyleOutlined';
import ContentCutRoundedIcon from '@mui/icons-material/ContentCutRounded';
import CalendarMonthRoundedIcon from '@mui/icons-material/CalendarMonthRounded';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';


// Tabs
import DetailsTab from "./Tabs/Details";
import InvoiceTab from "../Inventory/Tabs/Invoice";
import OrdersTab from "./Tabs/Orders";


// import SecurityTab from "./Tabs/Security";



  const tabContent = [
    {panel: "details", content: <DetailsTab />},
    {panel: "orders", content: <OrdersTab />},
    {panel: "invoice", content: <InvoiceTab />},
  ]

const ViewAppointment = () => {

  const tabs = [
    {label: "Details", icon: <ContactPageOutlinedIcon fontSize="small" />},
    {label: "Orders", icon: <StyleOutlinedIcon fontSize="small" />},
    {label: "Invoice", icon: <ReceiptLongRoundedIcon fontSize="small" />, showTab: (data) => !!data?.invoice_id},
  ];

  return (
    <NewEventProvider>
      <ViewDetails title="Appointment" identifier="client_name" tabs={tabs} tabContent={tabContent} url="appointments" show_breadcrumbs={false}>

      </ViewDetails>
    </NewEventProvider>
  )
};

export default ViewAppointment;